'use strict';

var App = require('app');
var Consts = require('consts');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var Utils = require('models/utils');

var GroupModel = Backbone.Model.extend({
    urlRoot: function () {
        return '/api/v1/groups';
    },
    initialize: function (options) {
        Backbone.Select.Me.applyTo(this);
    },
});

var GroupCollection = OOP.extend(
    Backbone.Collection,
    {
        model: GroupModel,
        url: function () {
            var url = this.userGroupMode != '' ? '?mode=' + this.userGroupMode : '';
            return '/api/v1/groups' + url;
        },
        initialize: function (initData, options) {
            this.base.initialize();
            Utils.SelectableCollection.applyTo(this);
            this.userGroupMode = options.userGroupMode;
        },
    },
    'GroupCollection'
);

var API = {
    getGroupList: function (userGroupMode) {
        var defer = $.Deferred();
        var list = new GroupCollection([], { userGroupMode: userGroupMode });
        list.fetch({
            success: function (data) {
                _.each(data.models, function (m) {
                    m.selectable = !m.get('is_default');
                    if (m.get('is_default')) {
                        m.set('name', I18N.TR('Standard'));
                    }
                });
                defer.resolve(list);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    inviteToGroups: function (emailList, groups) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'POST',
                url: '/api/v1/groups/invite',
                data: JSON.stringify({ emails: emailList, groups: groups }),
                success: function (result) {
                    defer.resolve(undefined);
                },
                error: function (data) {
                    defer.resolve(data);
                },
            });
        });
    },

    deleteGroupUser: function (groupID, userID) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'DELETE',
                url: '/api/v1/groups',
                data: JSON.stringify({ group_id: groupID, user_id: userID }),
                success: function (result) {
                    defer.resolve(undefined);
                },
                error: function (data) {
                    defer.resolve(data.responseJSON || { error: Consts.ErrorMessages['general_error'] });
                },
            });
        });
    },
};

App.reqres.setHandler('groups:list', function (userGroupMode) {
    return API.getGroupList(userGroupMode);
});

App.reqres.setHandler('groups:invite', function (emailList, groups) {
    return API.inviteToGroups(emailList, groups);
});

App.reqres.setHandler('group:delete:user', function (groupID, userID) {
    return API.deleteGroupUser(parseInt(groupID), parseInt(userID));
});

module.exports = {
    Model: GroupModel,
    Collection: GroupCollection,
};
